import { BaseIcon, BaseIconProps } from './BaseIcon';

export const ImageIconGradient: React.FC<BaseIconProps> = (props) => (
  <BaseIcon gradientId="imageIconGrad" {...props}>
    <rect width="18" height="18" x="3" y="3" rx="2" ry="2" stroke="url(#imageIconGrad)" />
    <circle cx="9" cy="9" r="2" stroke="url(#imageIconGrad)" />
    <path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21" stroke="url(#imageIconGrad)" />
  </BaseIcon>
);
